import LTR from "@brand-icons/global/plus-falling/plus-falling-ltr.svg";

import { iconFactory } from "../iconFactory";

export const PlusFallingIcon = iconFactory("PlusFallingIcon", LTR);
